import {createActions} from 'client/framework';

export default createActions(null, ['SELECT_OPTION']);
